var exports = {
  "Qs": "x43aef4ae--32c23e--content",
  "su": "x43aef4ae--32c23e--icon-wrapper",
  "R_": "x43aef4ae--32c23e--heading",
  "qr": "x43aef4ae--32c23e--footer",
};

module.exports = exports;
